module.exports = __webpack_public_path__ + "assets/img/hill-2.5402a38e.png";